module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-256x256-6f96649d3d686f9f6efb83a81bf7a261.png";